import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { SideBarNotification } from '@app/core/models';
import { AuthService } from '@app/core/services';
import { unloadSavedSearch } from '@app/core/store/actions/results.actions';
import { getSideBarNotificationList } from '@app/core/store/actions/side-bar-notification.actions';
import { AppState } from '@app/core/store/reducers';
import { selectSideBarNotificationState } from '@app/core/store/reducers/side-bar-notification.reducer';
import { selectCurrentUser } from '@app/core/store/reducers/users.reducer';
import { GlobalConstants } from '@app/portal/global-constants';
import { NgbOffcanvas, OffcanvasDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { ShareMenuComponent } from '../share-menu-component';


@Component({
  selector: 'app-header-application',
  templateUrl: './header-application.component.html'
})
export class HeaderApplicationComponent extends ShareMenuComponent {

  appTitle = GlobalConstants.appInfo.appTitle;
  mainNav = GlobalConstants.mainNav;
  closeResult = '';

  sideBarNotifications: SideBarNotification[] = [];
  showNotification = false;
  isNavbarCollapsed = true;

  constructor(private offcanvasService: NgbOffcanvas, protected store: Store<AppState>, private router: Router,
    private authService: AuthService) {

    super(store);


    store.select(selectCurrentUser).pipe(takeUntilDestroyed()).subscribe(user => {
      if (user) {
        this.user = user;
        if (this.user.allowSearch) {
          store.dispatch(getSideBarNotificationList());
        }
      }
    });

    store.select(selectSideBarNotificationState).pipe(takeUntilDestroyed()).subscribe(selectSideBarNotificationState => {
      this.sideBarNotifications = selectSideBarNotificationState.sideBarNotificationList;
    });
  }


  navigateToSearch(): void {
    this.store.dispatch(unloadSavedSearch());
  }

  public async signOut(): Promise<void> {
    return this.authService.signOut();
  }

  openMainNav(offcanvasMainNav: any) {
    this.offcanvasService
      .open(offcanvasMainNav, {
        ariaLabelledBy: 'offcanvas-main-nav',
        position: 'start',
        panelClass: 'text-bg-navy',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  openUserNav(offcanvasUserNav: any) {
    this.offcanvasService
      .open(offcanvasUserNav, {
        ariaLabelledBy: 'offcanvas-UserNav',
        position: 'end',
        panelClass: 'text-bg-navy',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === OffcanvasDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === OffcanvasDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on the backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}

